//messages.js
export default {
    id: "Id",
    device_id: "Device Id",
    wo_number: "Work Order Number",
    inbound_tracking_number: "Inbound Tracking Number",
    reason_for_return: "Reason For Return",
    return_address: "Return Address",
    contact_name: "Contact Name",
    country_id: "Country Id",
    contact_phone: "Contact Phone",
    contact_phone_formatted: "Contact Phone Formatted",
    contact_email: "Contact Email",
    warranty_repair: "Warranty",
    zoho_estimate_id: "Zoho Estimate Id",
    work_performed: "Work Performed",
    outbound_tracking_number: "Outbound Tracking Number",
    date_performed: "Date Performed",
    performed_by: "Performed By",
    wo_requested_by: "Wo Requested By",
    private_notes: "Private Notes",
    status_id: "Status Id",
    edit_work_order: "Edit Work Order",
    add_work_order: "Add Work Order",
    delete_work_order: "Delete Work Order",
    work_orders: "Work Orders",
    delete_work_order_confirm: "This action is not reversible!",
    receive_wo: "Receive WO",
    warranty: "Warranty",
    contact: "Contact",
    zoho_customer: "Zoho Customer",
    date_completed: "Completed",
    outbound_shipments: "Outbound Shipments",
    outbound_tracking_number: "Outbound Tracking #",
    not_done: "Not Done",
    done: "Done",
    attach_estimate: "Attach Estimate",
    update_status: "Update Status",
    WorkOrders: "Work Orders",
    attach: "Attach",
    edit_work_order_status: "Change Status",
    estimate_number_short: "Estimate #",
    created: "Created",
    device_received: "Device Received",
    track_parcel: "Track Parcel",
    outbound_shipping_carrier: "Outbound Shipping Carrier",
    finished: "Finished",
};
